/* @ngInject */

export default (webpage) => {
  webpage.pageTitle('Organization Suspended');
};
